import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import PropTypes from "prop-types";
import { BaasicButton, BaasicDropdown, GlobalItemChangeListener } from 'core/components';
import { defaultTemplate } from "core/hoc";
import { PatientInformationBarNewFlow } from "application/facility-order-new-flow/components";
import { DropDownButton, DropDownButtonItem, Button } from "@progress/kendo-react-buttons";
import { toDate, handleKeyDown, handlePaste } from "core/utils";
import { observer } from "mobx-react";

const FacilityOrderPatientNewFlowUSIntakePreviewTemplate = function ({ facilityOrderPatientNewFlowUSIntakePreviewViewStore, selectedStatusAbrv, disabled, disabledSendOrder, facilityOrderStatus }) {
	const {
		hospitalClassName,
		dischargedClassName,
		expiredClassName,
		activeClassName,
		disabledPatient,
		patient,
		isQtyChange,
		facilityOrder,
		facilityOrderPatient,
		facilityOrderTemplates,
		isMasterPatient,
		pageViewStore,
		inactiveOptions,
		inactiveOptionStore,
		inactiveOptionStoreId,
		openExtraSuppliesApprovalRequiredModal,
		openFacilityOrderTemplateItemNewFlowActivatePatientModal,
		showPreviousFlag,
		reviewTemplates,
		reviewDischargeTemplates,
		setInsuranceStatus,
		openFacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal,
		openFacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal,
		openFacilityOrderPatientNewFlowInsuranceEditModal,
		openFacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal,
		openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal,
		openInsuranceInformation,
		reviewPatient,
		getSelectedInactiveOption,
		changeInsuranceInfo,
		updateFacilityOrderPatient,
		insuranceInfo,
		patientNote,
		oldTemplate
	} = facilityOrderPatientNewFlowUSIntakePreviewViewStore;

	const handleDropDownInsuranceItemsOnClick = async (e) => {
		if (e.item.text === "No changes") {
			setInsuranceStatus("no-change")
		}
		else if (e.item.text === "Change/Review") {
			setInsuranceStatus("change", true)
		}
	}

	const anyHistory = () => {
		return selectedStatusAbrv === "in-progress" && !facilityOrderPatient.isNewPatient && (
			(oldTemplate && ((patient.primaryInsurance || null) != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.primaryInsurance : null) || (patient.primaryPolicyNo || null) != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.primaryPolicyNo : null)))
			|| (oldTemplate && ((oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.primaryInsurance) !== "Medicare" || patient.primaryInsurance !== "Medicare") && patient.inactiveMedicareNo != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.inactivePrimaryPolicyNo : null))
			|| (oldTemplate && ((patient.secondaryInsurance || null) != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.secondaryInsurance : null) || (patient.secondaryPolicyNo || null) != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.secondaryPolicyNo : null)))
			|| (oldTemplate && (!(oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance.includes("Medicaid")) || !patient.secondaryInsurance.includes("Medicaid")) && patient.inactiveMedicaidNo != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.inactiveSecondaryPolicyNo : null))
			|| (facilityOrderPatient && facilityOrderPatient.eligibilityStatusId != (facilityOrderPatient.facilityOrderPatientInitial ? facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatusId : ""))
			|| (facilityOrderTemplates && facilityOrderTemplates.some(item => (item.templateId && (item.isPriorAuthNeeded ? true : false) != (item.facilityOrderTemplateInitial && item.facilityOrderTemplateInitial.isPriorAuthNeeded ? true : false))))
		)
	}

	return (
		(facilityOrderTemplates && facilityOrderTemplates.length > 0 && facilityOrderPatient) ?
			<div className="card--tertiary u-mar--bottom--sml--alt">
				<GlobalItemChangeListener isChanged={isQtyChange} />
				<ReactTooltip positionStrategy="fixed" id={"registerPatientBottomTip" + facilityOrderPatient.id} place="bottom" />
				<ReactTooltip positionStrategy="fixed" id={"registerPatientTopTip" + facilityOrderPatient.id} place="top" />
				<div className={`card--tertiary__header ${selectedStatusAbrv === "discharge" ? "" : "card--tertiary__header--insurance"}`}>
					<div className="u-flex--default">
						<h4 className="card--tertiary__header__title">
							{patient.lastName && `${patient.lastName}`}
							{patient.lastName && patient.firstName && ', '}
							{patient.firstName && `${patient.firstName}`}
						</h4>
						<PatientInformationBarNewFlow disabled={disabled || disabledSendOrder} patient={patient} role="US Intake Single" isNewPatient={facilityOrderPatient.isNewPatient} isMasterPatient={isMasterPatient} facilityOrder={facilityOrder} />
					</div>
					{
						facilityOrderPatient.isNewPatient && selectedStatusAbrv === "discharge" &&
						<div className="status status--sml status--success">
							<p>New Patient</p>
						</div>
					}
					<div className="u-flex--default u-align--h--right">
						<BaasicButton
							className="btn btn--icon--sml-med btn--light is-plus u-mar--right--xsml"
							icon="u-icon u-icon--xmed u-icon--add-lined"
							label="Add Template"
							onlyIcon={true}
							onClick={() => { openExtraSuppliesApprovalRequiredModal(isMasterPatient) }}
							disabled={disabled || disabledPatient || disabledSendOrder}
						/>
						{
							facilityOrderTemplates.some(x => x.newFlowStatusId === pageViewStore.inProgressNewFlowStatusId) ?
								<div className="segmented-control u-mar--left--xsml">
									<Button key={inactiveOptions[0].id} className={hospitalClassName} onClick={() => openFacilityOrderTemplateItemNewFlowActivatePatientModal(inactiveOptions[0].id)} disabled={disabled || disabledSendOrder || disabledPatient}>{inactiveOptions[0].name}</Button>
									<Button key={inactiveOptions[1].id} className={dischargedClassName} onClick={() => openFacilityOrderTemplateItemNewFlowActivatePatientModal(inactiveOptions[1].id)} disabled={disabled || disabledSendOrder || disabledPatient}>{inactiveOptions[1].name}</Button>
									<Button key={inactiveOptions[2].id} className={expiredClassName} onClick={() => openFacilityOrderTemplateItemNewFlowActivatePatientModal(inactiveOptions[2].id)} disabled={disabled || disabledSendOrder || disabledPatient}>{inactiveOptions[2].name}</Button>
									<Button key={inactiveOptions[3].id} className={activeClassName} onClick={() => openFacilityOrderTemplateItemNewFlowActivatePatientModal(inactiveOptions[3].id)} disabled={disabled || disabledSendOrder || disabledPatient}>
										{inactiveOptions[3].name}{facilityOrderPatient.activeStatus === "Active" && showPreviousFlag() &&
											<div className="previous-status" data-tooltip-content={`Previous: ${facilityOrderPatient.facilityOrderPatientInitial ? facilityOrderPatient.facilityOrderPatientInitial.activeStatus : ''}`} data-tooltip-id={"registerPatientTopTip" + facilityOrderPatient.id}></div>
										}
									</Button>
								</div>
								:
								<React.Fragment>
									<div className={`${showPreviousFlag() ? "k-dropdown--status-indicator" : ""} w--200--px u-align--h--right u-mar--left--xsml`} >
										<div className="k-dropdown--tooltip" data-tooltip-content={showPreviousFlag() ? `Previous: ${facilityOrderPatient.facilityOrderPatientInitial ? facilityOrderPatient.facilityOrderPatientInitial.activeStatus : ''}` : ''} data-tooltip-id={showPreviousFlag() ? `registerPatientTopTip${facilityOrderPatient.id}` : ""}></div>
										<BaasicDropdown store={inactiveOptionStore} value={inactiveOptionStoreId} onChange={(e) => { openFacilityOrderTemplateItemNewFlowActivatePatientModal(e.value.id) }} disabled={disabled || disabledSendOrder || disabledPatient} />
									</div>
								</React.Fragment>
						}
						{selectedStatusAbrv === "in-progress" &&
							<BaasicButton
								className="btn btn--base btn--primary u-mar--left--xsml"
								icon="u-icon u-icon--med u-icon--check-list"
								label="Review All"
								onlyIcon={false}
								onClick={() => { reviewTemplates() }}
								disabled={disabled || disabledSendOrder || disabledPatient || (((facilityOrderPatient.isNewPatient || facilityOrderTemplates.every(x => x.newFlowInsuranceStatusId === pageViewStore.changeNewFlowStatusId)) && (facilityOrderTemplates.some(x => x.newFlowInsuranceStatusId === pageViewStore.inProgressNewFlowStatusId) || !(facilityOrderPatient.isReviewed && facilityOrderTemplates.every(x => x.newFlowUSIntakeStatusId === pageViewStore.noChangeNewFlowStatusId)))) || (facilityOrderTemplates.every(x => x.newFlowInsuranceStatusId === pageViewStore.noChangeNewFlowStatusId) && !facilityOrderTemplates.every(x => x.newFlowUSIntakeStatusId === pageViewStore.noChangeNewFlowStatusId)) || (facilityOrderTemplates.some(x => x.newFlowInsuranceStatusId === pageViewStore.inProgressNewFlowStatusId)))}
							/>
						}
						{selectedStatusAbrv === "discharge" &&
							<BaasicButton
								className="btn btn--base btn--primary u-mar--left--xsml"
								icon="u-icon u-icon--med u-icon--check-list"
								label="Review"
								onlyIcon={false}
								onClick={() => { reviewDischargeTemplates() }}
								disabled={disabled || disabledSendOrder || disabledPatient || !facilityOrderTemplates.some(i => !i.isReviewed)}
							/>
						}
					</div>
				</div>
				{selectedStatusAbrv !== "discharge" &&
					<div className="card--tertiary__subheader btn--group__wrapper">
						<div className="card--tertiary__flex">
							<div className="status--sqare__wrapper u-mar--left--xsml">
								<BaasicButton
									type='button'
									className="btn btn--base-plus btn--light btn--uppercase"
									label={facilityOrderPatient.eligibilityStatus ? facilityOrderPatient.eligibilityStatus.name : "Blank"}
									disabled={disabled || disabledSendOrder || disabledPatient}
									onClick={() => { setInsuranceStatus("change", true) }}
								/>
								{facilityOrderPatient.eligibilityStatus && facilityOrderPatient.eligibilityStatus.name != "Eligible" && <Button className="btn btn--link u-mar--left--tny" icon="u-icon u-icon--med u-icon--us-note" onClick={() => openFacilityOrderPatientNewFlowUSIntakeEligibilityStatusNoteModal()} disabled={disabled || disabledSendOrder || disabledPatient} data-tooltip-content="Eligibility Status Note" data-tooltip-id={"registerPatientBottomTip" + facilityOrderPatient.id} />}
							</div>
							{patient &&
								<div className="card--tertiary__data">
									<div>
										<div className="card--tertiary__data__item">
											<div>Primary:</div>
											<div className="type--color--primary type--wgt--semibold">{patient.primaryInsurance}</div>
											{patient.primaryPolicyNo &&
												<div>{patient.primaryPolicyNo}</div>
											}
										</div>
										{patient.primaryInsurance !== "Medicare" && patient.inactiveMedicareNo &&
											<div className="card--tertiary__data__item">
												<div>Inactive:</div>
												<div className="type--color--primary type--wgt--semibold">Medicare</div>
												{patient.inactiveMedicareNo &&
													<div>{patient.inactiveMedicareNo}</div>
												}
											</div>
										}
									</div>
									<div>
										<div className="card--tertiary__data__item">
											<div>Secondary:</div>
											<div className="type--color--primary type--wgt--semibold">{patient.secondaryInsurance}</div>
											{patient.secondaryPolicyNo &&
												<div>{patient.secondaryPolicyNo}</div>
											}
										</div>
										{!patient.secondaryInsurance.includes("Medicaid") && patient.inactiveMedicaidNo &&
											<div className="card--tertiary__data__item">
												<div>Inactive:</div>
												<div className="type--color--primary type--wgt--semibold">Medicaid</div>
												{patient.inactiveMedicaidNo &&
													<div>{patient.inactiveMedicaidNo}</div>
												}
											</div>
										}
									</div>
								</div>
							}
							{
								facilityOrderPatient.insuranceQuestion &&
								<div className="u-flex u-flex--default u-flex--gap--2">
									<div className="card--tertiary__header__divider"></div>
									<Button className="btn btn--status--red u-mar--left--xsml" icon="u-icon u-icon--med-lrg u-icon--us-question-note--red" onClick={() => { openFacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal() }} disabled={disabled || disabledPatient} />
								</div>
							}
							<div className="u-flex u-flex--default u-align--h--right">
								<div className="btn--group">
									<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-edit" onClick={() => openFacilityOrderPatientNewFlowInsuranceEditModal()} disabled={disabled || disabledSendOrder || disabledPatient} data-tooltip-content="Edit Insurance" data-tooltip-id={"registerPatientBottomTip" + facilityOrderPatient.id} />
									{!facilityOrderPatient.insuranceQuestion && <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-question-note-sh" onClick={() => openFacilityOrderTemplateNewFlowUSIntakeInsuranceQuestionModal()} disabled={disabled || disabledPatient} data-tooltip-content="Insurance Question" data-tooltip-id={"registerPatientBottomTip" + facilityOrderPatient.id} />}
									<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-note" onClick={() => openFacilityOrderPatientNewFlowUSIntakeInsuranceInfoModal()} disabled={disabled || disabledSendOrder || disabledPatient} data-tooltip-content="Insurance Info Note" data-tooltip-id={"registerPatientBottomTip" + facilityOrderPatient.id} />
									<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-history" onClick={() => openFacilityOrderTemplateNewFlowInsuranceHistoryOfChangesModal()} disabled={disabled || disabledPatient} data-tooltip-content="Change History" data-tooltip-id={"registerPatientBottomTip" + facilityOrderPatient.id} />
									<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-insurance-external-link" onClick={() => openInsuranceInformation()} disabled={disabled || disabledPatient} data-tooltip-content="Brightree" data-tooltip-id={"registerPatientBottomTip" + facilityOrderPatient.id} />
									<div className="btn--group__divider"></div>
								</div>
								{
									facilityOrderTemplates.filter(fot => fot.isPriorAuthNeeded).length > 0 &&
									<BaasicButton
										type='button'
										className="btn btn--base-plus btn--light is-grey no-click u-mar--right--tny"
										label={`PAR ${facilityOrderTemplates.filter(fot => fot.isPriorAuthNeeded).length}/${facilityOrderTemplates.length}`}
										disabled={disabled || disabledSendOrder}
									/>
								}
								<div className="status--sqare__wrapper" data-tooltip-content={!facilityOrderPatient.eligibilityStatusId ? "Eligibility Status must be selected" : ""} data-tooltip-id={!facilityOrderPatient.eligibilityStatusId ? `registerPatientBottomTip${facilityOrderPatient.id}` : ""}>
									{
										selectedStatusAbrv === "in-progress" && (facilityOrderPatient.isNewPatient || facilityOrderTemplates.every(x => x.newFlowInsuranceStatusId === pageViewStore.changeNewFlowStatusId)) &&
										<Button className="btn btn--icon btn--icon--sml-med btn--primary u-mar--left--xsml" icon={`${facilityOrderPatient.isReviewed ? "u-icon u-icon--med u-icon--unreview" : "u-icon u-icon--med u-icon--us-question-note-sh--light"}`} onClick={() => reviewPatient()} disabled={disabled || disabledPatient || disabledSendOrder || !facilityOrderPatient.eligibilityStatusId} data-tooltip-content={`${facilityOrderPatient.isReviewed ? "Unreview Insurance" : "Review Insurance"}`} data-tooltip-id={"registerPatientBottomTip" + facilityOrderPatient.id} />
									}
								</div>
								{facilityOrderPatient.isNewPatient ?
									<div className={`card--tertiary__status--card ${disabled || disabledSendOrder || disabledPatient ? "is-disabled" : ""}`}>
										<div className={`status--sqare__holder yellow`}>
											<div className="status--sqare__wrapper">
												<Button className="btn status--square btn--yellow" icon="u-icon u-icon--xsml u-icon--persons--yellow" onClick={() => setInsuranceStatus("change")} disabled={disabled || disabledSendOrder || disabledPatient}>NEW PATIENT</Button>
											</div>
										</div>
									</div>
									:
									facilityOrderTemplates.some(x => x.newFlowInsuranceStatusId === pageViewStore.inProgressNewFlowStatusId) ?
										<div className="card--tertiary__status--card">
											<div className="status--sqare__holder default">
												<div className="status--sqare__wrapper">
													<div className="status--sqare__not-assigned">
														<i className="u-icon u-icon--xxsml u-icon--info-fill"></i>
														<div>not assigned</div>
													</div>
													<Button className="btn btn--icon--sml is-not-assigned status--sqare reload" onClick={() => setInsuranceStatus("change", true)} disabled={disabled || disabledSendOrder || disabledPatient} data-tooltip-content="Change / Review Needed" data-tooltip-id={"registerPatientBottomTip" + facilityOrderPatient.id} />
													<Button className="btn btn--icon--sml is-not-assigned status--sqare success" onClick={() => setInsuranceStatus("no-change")} disabled={disabled || disabledSendOrder || disabledPatient} data-tooltip-content="No Change" data-tooltip-id={"registerPatientBottomTip" + facilityOrderPatient.id} />
												</div>
											</div>
										</div> :
										<div className={`card--tertiary__status--card ${disabled || disabledSendOrder || disabledPatient ? "is-disabled" : ""}`}>
											<div className={`status--sqare__holder ${getSelectedInactiveOption("insurance") === "success" ? "success" : "warning"}`}>
												<div className="status--sqare__wrapper">
													<DropDownButton
														text={getSelectedInactiveOption("insurance") === "success" ? "NO CHANGES" : "CHANGES"}
														fillMode={"solid"}
														themeColor={"primary"}
														onItemClick={(e) => handleDropDownInsuranceItemsOnClick(e)}
														buttonClass={`btn btn--base btn--ghost k-dropdown-button--icons status--sqare ${getSelectedInactiveOption("insurance") === "success" ? "success" : getSelectedInactiveOption("insurance") === "change" ? "reload" : ""}`}
														disabled={disabled || disabledSendOrder || disabledPatient}
														popupSettings={{
															animate: false,
															anchorAlign: { horizontal: "right", vertical: "bottom" },
															popupAlign: { horizontal: "right", vertical: "top" },
															popupClass: 'is-clean'
														}}
													>
														{(getSelectedInactiveOption("insurance") === "change" || (getSelectedInactiveOption("insurance") !== "success" && getSelectedInactiveOption("insurance") !== "change")) && <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--success" text="No changes" />}
														{(getSelectedInactiveOption("insurance") === "success" || (getSelectedInactiveOption("insurance") !== "success" && getSelectedInactiveOption("insurance") !== "change")) && <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--change" text="Change/Review" />}
													</DropDownButton>
												</div>
											</div>
										</div>
								}
							</div>
						</div>
						<div>
							{facilityOrderPatient.insuranceInfo &&
								<div className="c-message has-input c-message--note u-mar--top--sml">
									<i className="u-icon u-icon--sml u-icon--add-note" />
									<input
										className="input input--sml input--message u-flex--grow--1 type--sml"
										onClick={(e) => e.target.select()}
										onChange={(e) => { changeInsuranceInfo(e.target.value) }}
										onBlur={async () => { await updateFacilityOrderPatient(true) }}
										value={insuranceInfo}
										disabled={disabled || disabledSendOrder}
									/>
								</div>
							}
							{
								!facilityOrderPatient.isReviewed && selectedStatusAbrv !== "intake-reviewed" &&
								(
									facilityOrderPatient && facilityOrderPatient.note
									|| anyHistory()
								) &&
								<div className={`u-mar--top--lrg c-message ${!facilityOrderPatient.isNewPatient ? 'c-message--orange' : 'c-message--note--primary c-message--note--primary--tab'}`}>
									{facilityOrderPatient && facilityOrderPatient.note &&
										<div className={`has-input ${facilityOrderPatient.isNewPatient || !anyHistory() ? '' : 'c-message--has-border'} u-flex--default u-flex--gap--1 w--100`} >
											Note: <p style={{ fontWeight: "normal" }}>{patientNote}</p>
											<div className="u-align--h--right type--whitespace--nowrap">
												{
													facilityOrderPatient.effectiveDate &&
													<React.Fragment>Effective Date: {facilityOrderPatient.effectiveDate ? toDate(facilityOrderPatient.effectiveDate) : ""}</React.Fragment>
												}
											</div>
										</div>
									}
									{selectedStatusAbrv === "in-progress" && !facilityOrderPatient.isNewPatient && oldTemplate && ((patient.primaryInsurance || null) != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.primaryInsurance : null) || (patient.primaryPolicyNo || null) != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.primaryPolicyNo : null)) &&
										<div className="u-flex--default u-flex--gap--2 c-message--content">
											<div>Primary Active changed</div>
											<div className="type--color--secondary type--wgt--regular">{oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.primaryInsurance ? oldTemplate.facilityOrderTemplateInitial.primaryInsurance : "Empty"}</div>
											{oldTemplate.facilityOrderTemplateInitial && patient.primaryInsurance == oldTemplate.facilityOrderTemplateInitial.primaryInsurance && oldTemplate.facilityOrderTemplateInitial.primaryPolicyNo &&
												<div className="type--color--secondary type--wgt--regular"> {oldTemplate.facilityOrderTemplateInitial.primaryPolicyNo} </div>
											}
											<div className="type--color--secondary type--wgt--regular"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></div>
											<div>{patient.primaryInsurance ? patient.primaryInsurance : "Empty"}</div>
											{patient.primaryInsurance == (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.primaryInsurance : null) && patient.primaryPolicyNo && <div> {patient.primaryPolicyNo} </div>}
										</div>
									}
									{selectedStatusAbrv === "in-progress" && !facilityOrderPatient.isNewPatient && oldTemplate && ((oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.primaryInsurance) !== "Medicare" || patient.primaryInsurance !== "Medicare") && patient.inactiveMedicareNo != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.inactivePrimaryPolicyNo : null) &&
										<div className="u-flex--default u-flex--gap--2 c-message--content">
											<div>Primary Inactive changed</div>
											<div>{(oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.primaryInsurance) !== "Medicare" ? 'Medicare' : "Empty"}</div>
											{oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.inactivePrimaryPolicyNo &&
												<div className="type--color--secondary type--wgt--regular"> {oldTemplate.facilityOrderTemplateInitial.inactivePrimaryPolicyNo} </div>}
											<div className="type--color--secondary type--wgt--regular"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></div>
											<div>{patient.primaryInsurance !== "Medicare" ? 'Medicare' : "Empty"}</div>
											{patient.inactiveMedicareNo && <div> {patient.inactiveMedicareNo} </div>}
										</div>
									}
									{selectedStatusAbrv === "in-progress" && !facilityOrderPatient.isNewPatient && oldTemplate && ((patient.secondaryInsurance || null) != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.secondaryInsurance : null) || (patient.secondaryPolicyNo || null) != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.secondaryPolicyNo : null)) &&
										<div className="u-flex--default u-flex--gap--2 c-message--content">
											<div>Secondary Active changed</div>
											<div className="type--color--secondary type--wgt--regular">{oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance ? oldTemplate.facilityOrderTemplateInitial.secondaryInsurance : "Empty"}</div>
											{oldTemplate.facilityOrderTemplateInitial && patient.secondaryInsurance == oldTemplate.facilityOrderTemplateInitial.secondaryInsurance && oldTemplate.facilityOrderTemplateInitial.secondaryPolicyNo &&
												<div className="type--color--secondary type--wgt--regular"> {oldTemplate.facilityOrderTemplateInitial.secondaryPolicyNo} </div>}
											<div className="type--color--secondary type--wgt--regular"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></div>
											<div>{patient.secondaryInsurance ? patient.secondaryInsurance : "Empty"}</div>
											{patient.secondaryInsurance == (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.secondaryInsurance : null) && patient.secondaryPolicyNo && <div> {patient.secondaryPolicyNo} </div>}
										</div>
									}
									{selectedStatusAbrv === "in-progress" && !facilityOrderPatient.isNewPatient && oldTemplate && (!(oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance.includes("Medicaid")) || !patient.secondaryInsurance.includes("Medicaid")) && patient.inactiveMedicaidNo != (oldTemplate.facilityOrderTemplateInitial ? oldTemplate.facilityOrderTemplateInitial.inactiveSecondaryPolicyNo : null) &&
										<div className="u-flex--default u-flex--gap--2 c-message--content">
											<div>Secondary Inactive changed</div>
											<div>{!(oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance && oldTemplate.facilityOrderTemplateInitial.secondaryInsurance.includes("Medicaid")) ? 'Medicaid' : "Empty"} </div>
											{oldTemplate.facilityOrderTemplateInitial && oldTemplate.facilityOrderTemplateInitial.inactiveSecondaryPolicyNo && <div className="type--color--secondary type--wgt--regular"> {oldTemplate.facilityOrderTemplateInitial.inactiveSecondaryPolicyNo} </div>}
											<div className="type--color--secondary type--wgt--regular"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></div>
											<div>{!patient.secondaryInsurance.includes("Medicaid") ? 'Medicaid' : 'Empty'}</div>
											{patient.inactiveMedicaidNo && <div> {patient.inactiveMedicaidNo} </div>}
										</div>
									}
									{selectedStatusAbrv === "in-progress" && !facilityOrderPatient.isNewPatient && facilityOrderPatient && facilityOrderPatient.eligibilityStatusId != (facilityOrderPatient.facilityOrderPatientInitial ? facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatusId : "") &&
										<div className="u-flex--default u-flex--gap--2 c-message--content">
											<div>Insurance status changed</div>
											<div className="type--color--secondary type--wgt--regular">{facilityOrderPatient.facilityOrderPatientInitial && facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatus ? facilityOrderPatient.facilityOrderPatientInitial.eligibilityStatus.name : "Empty"}</div>
											<div className="type--color--secondary type--wgt--regular"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></div>
											<div>{facilityOrderPatient.eligibilityStatus ? facilityOrderPatient.eligibilityStatus.name : "Empty"}</div>
										</div>
									}
									{selectedStatusAbrv === "in-progress" && !facilityOrderPatient.isNewPatient &&
										facilityOrderTemplates.map(item => {
											return (item.templateId && (item.isPriorAuthNeeded ? true : false) != (item.facilityOrderTemplateInitial && item.facilityOrderTemplateInitial.isPriorAuthNeeded ? true : false) &&
												<div key={item.id && "-par"} className="u-flex--default u-flex--gap--2 c-message--content">
													<div> {`${item.subCategory.name} template ${item.templateId} PAR changed`}</div>
													<div className="type--color--secondary type--wgt--regular">{item.facilityOrderTemplateInitial && item.facilityOrderTemplateInitial.isPriorAuthNeeded ? "TRUE" : "FALSE"}</div>
													<div className="type--color--secondary type--wgt--regular"><i className="u-icon u-icon--xxsml u-icon--arrow-text"></i></div>
													<div>{item.isPriorAuthNeeded ? "TRUE" : "FALSE"}</div>
												</div>
											);
										})
									}
								</div>
							}
						</div>
					</div>
				}
				<div className="card--tertiary__body">
					{
						selectedStatusAbrv === "discharge" ?
							facilityOrderTemplates.map(item => {
								return (
									<FacilityOrderTemplateDischargesTable
										key={item.id}
										facilityOrderPatientNewFlowUSIntakePreviewViewStore={facilityOrderPatientNewFlowUSIntakePreviewViewStore}
										facilityOrderTemplate={item}
										disabled={disabled || disabledSendOrder}
										facilityOrderStatus={facilityOrderStatus} />);
							}) :
							facilityOrderTemplates.map(item => {
								return (
									<FacilityOrderTemplateTable
										key={item.id}
										facilityOrderPatientNewFlowUSIntakePreviewViewStore={facilityOrderPatientNewFlowUSIntakePreviewViewStore}
										facilityOrderTemplate={item}
										disabled={disabled}
										disabledSendOrder={disabledSendOrder}
										facilityOrderStatus={facilityOrderStatus}
										selectedStatusAbrv={selectedStatusAbrv} />);
							})
					}
				</div>
			</div>
			:
			<React.Fragment />
	);
};

FacilityOrderPatientNewFlowUSIntakePreviewTemplate.propTypes = {
	facilityOrderPatientNewFlowUSIntakePreviewViewStore: PropTypes.object.isRequired,
	selectedStatusAbrv: PropTypes.string,
	disabled: PropTypes.bool,
	disabledSendOrder: PropTypes.bool,
	facilityOrderStatus: PropTypes.object,
};

const FacilityOrderTemplateTable = observer(({ facilityOrderTemplate, facilityOrderPatientNewFlowUSIntakePreviewViewStore, disabled, disabledSendOrder, facilityOrderStatus, selectedStatusAbrv }) => {
	const {
		getSelectedInactiveOption,
		templateExpanded,
		isMasterPatient,
		disabledPatient,
		openFacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal,
		addEmptyItem,
		facilityOrderPatient,
		sendAgoraPo,
		openFacilityOrderTemplateNewFlowInvoiceNoteModal,
		openFacilityOrderTemplateNewFlowUSIntakePortalNoteModal,
		openFacilityOrderTemplateDoNotSupplyModal,
		openFacilityOrderTemplateNewFlowUSIntakeClinicalInformationModal,
		setTemplateStatus,
		openFacilityOrderTemplateNewFlowDeleteModal,
		pageViewStore,
		facilityOrder,
		isDisabledTemplateReview,
		unreviewTemplate,
		reviewTemplates,
		updatePortalNote,
		showItemQuantities,
		productStore,
		saveItemOnProductSelect,
		editItem,
		updateItem,
		openFacilityOrderTemplateItemNewFlowCalculationModal,
		deleteFacilityOrderTemplateItem,
		setImportActionToDeleteAndAddItem,
		setImportAction,
		setItemToggle
	} = facilityOrderPatientNewFlowUSIntakePreviewViewStore;

	const isExpanded = () => {
		return isMasterPatient || (facilityOrderTemplate.id === templateExpanded.id && templateExpanded.expanded === true);
	}

	const tableColSpan = () => {
		if (facilityOrderTemplate.isDifferentQty) {
			return 6;
		}
		if (!isExpanded()) {
			return 5;
		}
		else {
			return 6;
		}
	}

	const handleDropDownItemsOnClick = async (e, facilityOrderTemplateId) => {
		if (e.item.text === "No changes") {
			setTemplateStatus("no-change", facilityOrderTemplateId);
		}
		else if (e.item.text === "Change/Review") {
			setTemplateStatus("change", facilityOrderTemplateId);
		}
		else if (e.item.text === "Discontinued") {
			setTemplateStatus("discharge", facilityOrderTemplateId);
		}
	}

	const productDropdownItemRender = (li, itemProps) => {
		const itemName = itemProps && itemProps.dataItem.description;
		const isPreferredIcon = itemProps && itemProps.dataItem.isPreferred && facilityOrderTemplate.itemCategoryId === pageViewStore.ostomyItemCategoryId ?
			<i className="u-icon u-icon--xsml u-icon--star-outlined u-mar--right--tny"></i> : null;
		const isBackorderedIcon = itemProps && itemProps.dataItem.backordered ? <i className="u-icon u-icon--sml u-icon--backordered u-mar--left--tny"></i> : null;
		const nonBillableIcon = itemProps && !itemProps.dataItem.billableToMedicare ? <i className="u-icon u-icon--sml u-icon--non-billable u-mar--left--tny"></i> : null;
		const itemChildren = (
			<span style={{ display: "flex", flexDirection: "column", width: "100%", }}>
				<span style={{ flex: "1" }}> {li.props.children} </span>
				<span style={{ fontSize: "12px" }}> {isPreferredIcon} {itemName} {nonBillableIcon} {isBackorderedIcon}</span>
			</span>
		);
		return React.cloneElement(li, li.props, itemChildren);
	}

	const handleItemClick = (e) => {
		e.currentTarget.select();
		showItemQuantities(facilityOrderTemplate, true);
	};

	const isUnreviewDisabled = disabledPatient || disabled || disabledSendOrder || !!(facilityOrderStatus && facilityOrderStatus.completedOn) || (facilityOrderTemplate.isClinicalReviewed && (!!facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "clinical-review")));
	const dropdownRef = React.createRef();

	return (
		<div className={`table--secondary__wrapper u-mar--bottom--med--condition ${getSelectedInactiveOption("us-intake", facilityOrderTemplate)} ${disabled || disabledSendOrder || disabledPatient || (facilityOrderTemplate.facilityOrderTemplateItems && facilityOrderTemplate.facilityOrderTemplateItems.some(x => !x.productId)) ? 'is-add-new-disabled' : ''}`}>
			<ReactTooltip positionStrategy="fixed" id={"registerTemplateTip" + facilityOrderTemplate.id} place="bottom" />
			<table className="table--secondary w--100">
				<colgroup>
					<col width={400} />
					<col width={150} />
					{(isExpanded() || facilityOrderTemplate.isDifferentQty) && facilityOrderTemplate.facilityOrderTemplateItems.length > 0 && <col width={70} />}
					<col width={70} />
					<col />
					{<col width={70} />}
				</colgroup>
				<thead>
					<tr>
						<th colSpan={tableColSpan()} className="btn--group__wrapper">
							<div className="u-flex--space-between">
								<label>{facilityOrderTemplate.subCategory && facilityOrderTemplate.subCategory.name.toUpperCase()}</label>
								{facilityOrderTemplate.notCurrentTube != null && !facilityOrderTemplate.inactiveReasonId && facilityOrderTemplate.facilityOrderTemplateItems.some(x => x.product && x.importActionId != pageViewStore.deleteImportActionId && x.orderQuantity) &&
									<div className="u-mar--left--xsml u-mar--bottom--tny">
										{facilityOrderTemplate.notCurrentTube ? <i className="u-icon u-icon--med u-icon--calendar-x--dark" /> : <i className="u-icon u-icon--med u-icon--calendar-yes--dark" />}
									</div>
								}
								{
									facilityOrderTemplate.missingProduct &&
									<Button className="btn btn--status--red u-mar--left--xsml" icon="u-icon u-icon--med-lrg u-icon--missing-product" onClick={() => { openFacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal(facilityOrderTemplate) }} disabled={disabled || disabledPatient} />
								}
								{
									<div className="card--tertiary__header__actions u-align--h--right">
										<div className="btn--group">
											{facilityOrderPatient.eligibilityStatus && facilityOrderPatient.eligibilityStatus.name == "Eligible" &&
												<React.Fragment>
													<div className="status--sqare__wrapper">
														<BaasicButton
															type='button'
															className="btn btn--base-plus btn--light btn--uppercase is-nonclickable"
															label={facilityOrderTemplate.clinicalStatus.name || 'Unselected'}
															disabled={!facilityOrderTemplate.clinicalStatus.name}
														/>
													</div>
													<div className="btn--group__divider"></div>
												</React.Fragment>
											}
											{!sendAgoraPo && isMasterPatient && <Button className="btn no-hover" icon="u-icon u-icon--med u-icon--us-invoice-note" onClick={() => openFacilityOrderTemplateNewFlowInvoiceNoteModal(facilityOrderTemplate)} disabled={disabled || disabledSendOrder} data-tooltip-content="Invoice Note" data-tooltip-id={"registerTemplateTip" + facilityOrderTemplate.id} />}
											{selectedStatusAbrv === "intake-reviewed" &&
												<Button className="btn no-hover" icon={"u-icon u-icon--med-lrg u-icon--us-history"} onClick={() => { openFacilityOrderTemplateNewFlowUSIntakePortalNoteModal(facilityOrderTemplate) }} disabled={(disabled || disabledSendOrder || !facilityOrderTemplate.portalNote)} data-tooltip-content="View Note" data-tooltip-id={"registerTemplateTip" + facilityOrderTemplate.id} />
											}
											{!facilityOrderTemplate.missingProduct && <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-question-note" onClick={() => { openFacilityOrderTemplateNewFlowUSIntakeMissingProductNoteModal(facilityOrderTemplate) }} disabled={disabled || disabledPatient} data-tooltip-content="Missing Product" data-tooltip-id={"registerTemplateTip" + facilityOrderTemplate.id} />}
											{facilityOrderTemplate.inactiveReasonId !== 16 &&
												<React.Fragment>
													<div className="btn--group status--sqare__wrapper" data-tooltip-content={`${facilityOrderTemplate.inactiveReasonId == 16 ? "Unmark" : "Mark"} As Do Not Supply`} data-tooltip-id={(disabled || disabledSendOrder || disabledPatient || (facilityOrderTemplate.isDoNotSupply && facilityOrderTemplate.inactiveReasonId === 16) || facilityOrderTemplate.inactiveReasonId === 15) ? `registerTemplateTip${facilityOrderTemplate.id}` : ""}>
														<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--do-not-supply" onClick={() => { openFacilityOrderTemplateDoNotSupplyModal(facilityOrderTemplate) }} disabled={disabled || disabledSendOrder || disabledPatient || (facilityOrderTemplate.isDoNotSupply && facilityOrderTemplate.inactiveReasonId === 16)} data-tooltip-content={`${facilityOrderTemplate.inactiveReasonId == 16 ? "Unmark" : "Mark"} As Do Not Supply`} data-tooltip-id={"registerTemplateTip" + facilityOrderTemplate.id} />
													</div>
												</React.Fragment>
											}
											<Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--clinical-info" onClick={() => { openFacilityOrderTemplateNewFlowUSIntakeClinicalInformationModal(facilityOrderTemplate, disabledSendOrder) }} disabled={disabled || disabledPatient} data-tooltip-content="Clinical Info" data-tooltip-id={"registerTemplateTip" + facilityOrderTemplate.id} />
											{facilityOrderTemplate.templateId && <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--danger--primary" onClick={() => setTemplateStatus("discharge", facilityOrderTemplate.id, 58)} disabled={disabled || disabledSendOrder || disabledPatient} data-tooltip-content="Discontinued" data-tooltip-id={"registerTemplateTip" + facilityOrderTemplate.id} />}
											{!facilityOrderTemplate.templateId && <Button className="btn no-hover" icon="u-icon u-icon--delete--brand u-icon--med-lrg" onClick={() => openFacilityOrderTemplateNewFlowDeleteModal(facilityOrderTemplate.id)} disabled={disabled || disabledSendOrder || disabledPatient} data-tooltip-content="Delete template" data-tooltip-id={"registerTemplateTip" + facilityOrderTemplate.id} />}
											<div className="btn--group__divider"></div>
										</div>
										{
											facilityOrderTemplate.inactiveReasonId == 16 &&
											<div className={`card--tertiary__status--card is-dns ${(!facilityOrderTemplate.templateId || facilityOrderTemplate.newFlowStatusId === pageViewStore.newOrderNewFlowStatusId) ? "is-new-order" : facilityOrderTemplate.newFlowStatusId === pageViewStore.changeNewFlowStatusId ? "is-changes" : facilityOrderTemplate.newFlowStatusId === pageViewStore.inProgressNewFlowStatusId ? "is-not-assigned" : "is-no-changes"} ${disabled || disabledSendOrder || facilityOrderTemplate.isDoNotSupply ? "is-disabled" : ""}`} >
												<div className="status--sqare__holder dns">
													<Button icon="u-icon u-icon--xsml u-icon--slash" className={`btn btn--base btn--ghost k-dropdown-button--icons status--sqare btn--${facilityOrderTemplate.isDoNotSupply ? "dns" : "dns-opaque"}`} onClick={() => openFacilityOrderTemplateDoNotSupplyModal(facilityOrderTemplate)} disabled={disabled || disabledSendOrder || facilityOrderTemplate.isDoNotSupply}>Do Not Supply</Button>
												</div>
											</div>
										}
										{((!facilityOrderTemplate.templateId || (facilityOrderTemplate.newFlowStatusId === pageViewStore.newOrderNewFlowStatusId && (facilityOrderTemplate.importDetailStatusId === pageViewStore.importedImportDetailStatusId || facilityOrderTemplate.importDetailStatusId === pageViewStore.failedImportDetailStatusId))) && (facilityOrderTemplate.inactiveReasonId != 15 && facilityOrderTemplate.inactiveReasonId != 17 && facilityOrderTemplate.inactiveReasonId != 18)) ?
											<div className={`card--tertiary__status--card ${disabled || disabledSendOrder ? "is-disabled" : ""}`}>
												<div className="status--sqare__holder yellow">
													<div className="status--sqare__wrapper">
														<Button className="btn status--square btn--yellow" icon="u-icon u-icon--xsml u-icon--box--yellow" onClick={() => { }} disabled={disabled || disabledSendOrder}>NEW ORDER</Button>
													</div>
												</div>
											</div>
											:
											(!facilityOrderTemplate.newFlowUSIntakeStatusId || (facilityOrderTemplate.newFlowUSIntakeStatusId === pageViewStore.inProgressNewFlowStatusId) ?
												<div className="card--tertiary__status--card">
													<div className={`status--sqare__holder not-assigned`}>
														<div className="status--sqare__wrapper">
															<Button
																icon="u-icon u-icon--xxsml u-icon--info-fill u-mar--y--sml"
																className="btn btn--not-assigned"
																onClick={() => { }}
															>
																NOT ASSIGNED
															</Button>
														</div>
													</div>
												</div>
												:
												!((facilityOrderTemplate.newFlowUSIntakeStatusId === pageViewStore.inProgressNewFlowStatusId) ||
													(facilityOrderTemplate.newFlowUSIntakeStatusId === pageViewStore.intakeReviewedNewFlowStatusId && facilityOrderTemplate.newFlowStatusId === pageViewStore.inProgressNewFlowStatusId)) &&
												<div className={`card--tertiary__status--card ${disabled || disabledSendOrder || disabledPatient ? "is-disabled" : ""}`}>
													<div className={`status--sqare__holder ${facilityOrderTemplate.newFlowStatusId === pageViewStore.noChangeNewFlowStatusId ? "success" : facilityOrderTemplate.newFlowStatusId === pageViewStore.changeNewFlowStatusId ? "warning" : facilityOrderTemplate.newFlowStatusId === pageViewStore.dischargeNewFlowStatusId ? "danger" : ""}`}>
														<div className="status--sqare__wrapper">
															<DropDownButton
																text={`${facilityOrderTemplate.newFlowStatusId === pageViewStore.noChangeNewFlowStatusId ? "NO CHANGES" : facilityOrderTemplate.newFlowStatusId === pageViewStore.changeNewFlowStatusId ? "CHANGES" : facilityOrderTemplate.newFlowStatusId === pageViewStore.dischargeNewFlowStatusId ? "DISCONTINUED" : ""}`}
																fillMode={"solid"}
																themeColor={"primary"}
																onItemClick={(e) => handleDropDownItemsOnClick(e, facilityOrderTemplate.id)}
																buttonClass={`btn btn--base btn--ghost k-dropdown-button--icons status--sqare ${facilityOrderTemplate.newFlowStatusId === pageViewStore.noChangeNewFlowStatusId ? "success" : facilityOrderTemplate.newFlowStatusId === pageViewStore.changeNewFlowStatusId ? "warning" : facilityOrderTemplate.newFlowStatusId === pageViewStore.dischargeNewFlowStatusId ? "danger" : ""}`}
																disabled={disabled || disabledSendOrder || disabledPatient}
																popupSettings={{
																	animate: false,
																	anchorAlign: { horizontal: "right", vertical: "bottom" },
																	popupAlign: { horizontal: "right", vertical: "top" },
																	popupClass: 'is-clean'
																}}
															>
																{facilityOrderTemplate.newFlowStatusId !== pageViewStore.dischargeNewFlowStatusId && <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--danger" text="Discontinued" />}
															</DropDownButton>
														</div>
													</div>
												</div>
											)
										}
										{
											selectedStatusAbrv !== "intake-reviewed" ?
												<div data-tooltip-content={!facilityOrderPatient.eligibilityStatusId ? "Insurance changes must be reviewed" : null} data-tooltip-id={"registerTemplateTip" + facilityOrderTemplate.id}>
													<Button className="btn btn--icon btn--icon--lrg btn--primary" icon="u-icon u-icon--med u-icon--check-list" disabled={isDisabledTemplateReview() || disabledPatient || disabled || disabledSendOrder || !facilityOrderPatient.eligibilityStatusId} data-tooltip-content="Review" data-tooltip-id={"registerTemplateTip" + facilityOrderTemplate.id} onClick={() => { reviewTemplates(facilityOrderTemplate.id) }} />
												</div>
												:
												<div className="status--sqare__wrapper 111" data-tooltip-content={facilityOrderTemplate.isClinicalReviewed && isUnreviewDisabled ? "Template is clinically reviewed" : "Unreview"} data-tooltip-id={"registerTemplateTip" + facilityOrderTemplate.id}>
													<Button className="btn btn--icon btn--icon--lrg btn--primary" icon="u-icon u-icon--med u-icon--unreview" onClick={() => { unreviewTemplate(facilityOrderTemplate.id) }} disabled={isUnreviewDisabled} />
												</div>
										}
									</div>
								}
							</div>
							{facilityOrderTemplate.portalNote && selectedStatusAbrv !== "intake-reviewed" &&
								<div className={`u-mar--top--sml c-message has-input u-flex--default w--100 c-message--note${facilityOrderTemplate.newFlowUSIntakeStatusId === pageViewStore.noChangeNewFlowStatusId || facilityOrderTemplate.newFlowStatusId === pageViewStore.noChangeNewFlowStatusId ? "--green" : facilityOrderTemplate.newFlowUSIntakeStatusId === pageViewStore.changeNewFlowStatusId ? "--orange" : facilityOrderTemplate.newFlowUSIntakeStatusId === pageViewStore.newOrderNewFlowStatusId || !facilityOrderTemplate.templateId ? "--primary" : ""} u-mar--top--tny ${(isExpanded() || facilityOrderTemplate.isDifferentQty) && facilityOrderTemplate.facilityOrderTemplateItems.length > 0 ? 'u-mar--bottom--med' : ''}`}>
									<i className="u-icon u-icon--sml u-icon--add-note" />
									<input
										className="input input--sml input--message u-flex--grow--1 type--sml"
										onClick={(e) => e.target.select()}
										onChange={(e) => { facilityOrderTemplate.portalNote = e.target.value }}
										onBlur={async () => { await updatePortalNote(facilityOrderTemplate.id, facilityOrderTemplate.portalNote) }}
										value={facilityOrderTemplate.portalNote}
										disabled={disabled || disabledSendOrder || disabledPatient}
									/>
								</div>
							}
						</th>
					</tr>
					<tr>
						<th className="table__label--sml"></th>
						<th className="table__label--sml"></th>
						{(isExpanded() || facilityOrderTemplate.isDifferentQty) && facilityOrderTemplate.facilityOrderTemplateItems.length > 0 && <th className="table__label--sml"><span className="table__label--inner">TEMP QTY</span></th>}
						{(isExpanded() || facilityOrderTemplate.isDifferentQty) && facilityOrderTemplate.facilityOrderTemplateItems.length > 0 && <th className="table__label--sml"><span className="table__label--inner">SO QTY</span></th>}
					</tr>
				</thead>
				<tbody style={facilityOrderTemplate.inactiveReasonId == 16 ? { opacity: "0.5" } : {}}>
					{facilityOrderTemplate.facilityOrderTemplateItems.map((item, index) => {
						var isFormula = (item && item.product && item.product.itemType && (item.product.itemType.abrv === 'bottle' || item.product.itemType.abrv === 'can')) || (item.product && item.product.procedureCode_ && item.product.procedureCode_.abrv === "B4155");
						if (!item.product && item.toggle) {
							setTimeout(() => {
								if (dropdownRef.current) {
									// v14 dropped the inner .k-dropdown-wrap — the DropDownList root element is the clickable toggle
									const toggle = dropdownRef.current.element;
									if (toggle) {
										setItemToggle(item);
										toggle.click();
									}
								}
							}, 0);
						}
						return (
							<tr key={item.id} className={`${(facilityOrderTemplate.importActionId !==  pageViewStore.insertImportActionId && item.importActionId === pageViewStore.insertImportActionId && !facilityOrderPatient.isNewPatient) ? "new-row" : (item.importActionId === pageViewStore.deleteImportActionId ? "deleted-row" : "")} ${!item.product ? "is-focused" : ""}`}>
								<td className="table-col-input is-flex">
									{
										item.product ? <React.Fragment>{item.product.description} <span className="table__icons-wrapper"> {!item.product.billableToMedicare && <i className="u-icon u-icon--sml u-icon--non-billable"></i>} {(item.backordered != null ? item.backordered : item.product.backordered) && <i className="u-icon u-icon--med-lrg u-icon--backordered"></i>}</span></React.Fragment> :
											<BaasicDropdown
												placeholder="Select item name..."
												store={productStore}
												value={item.product}
												className="input--table"
												itemRender={productDropdownItemRender}
												onChange={(e) => { saveItemOnProductSelect(item, facilityOrderTemplate.facilityOrderTemplateItems, index, e.target.value, facilityOrderTemplate) }}
												disabled={disabled || disabledSendOrder || disabledPatient}
												customRef={dropdownRef}
											/>
									}
								</td>
								<td>
									{item.product && item.product.itemId}
								</td>
								<td className="table-col-input text-align-left has-input" id={"templateQuantity-" + facilityOrderTemplate.id}>
									<ReactTooltip positionStrategy="fixed" id={"registerTipItemChanged" + item.id} place="top" />
									{item.isTemplateQuantityChanged && <div className="table-col-input__notif" data-tooltip-id={"registerTipItemChanged" + item.id} data-tooltip-content={"Previous: " + (item.facilityOrderTemplateItemInitial && item.facilityOrderTemplateItemInitial.templateQuantity ? item.facilityOrderTemplateItemInitial.templateQuantity : "blank")}></div>}
									{item.product &&
										<input
											className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
											onClick={(e) => handleItemClick(e)}
											onKeyDown={handleKeyDown} 
											onPaste={handlePaste}
											onChange={(e) => { editItem(item, parseInt(e.target.value), 'templateQuantity') }}
											onBlur={() => { updateItem(item, facilityOrderTemplate, false, true) }}
											value={item.templateQuantity}
											type="number"
											min="0"
											disabled={disabled || disabledSendOrder || disabledPatient || isMasterPatient}
										/>
									}
									{(item.sendSeparatelyQty | 0) > 0 && <i className="u-icon u-icon--ss u-icon--sml table__icon--ss" data-tooltip-id={"registerTipItemChanged" + item.id} data-tooltip-content={item.sendSeparatelyQty} />}
								</td>
								{(isExpanded() || facilityOrderTemplate.isDifferentQty) &&
									<td className="table-col-input text-align-left has-input" id={"orderQuantity-" + facilityOrderTemplate.id}>
										<ReactTooltip positionStrategy="fixed" id={"registerTipItemChangedOrder" + item.id} place="top" />
										{item.isOrderQuantityChanged && <div className="table-col-input__notif" data-tooltip-id={"registerTipItemChangedOrder" + item.id} data-tooltip-content={"Previous: " + (item.facilityOrderTemplateItemInitial && item.facilityOrderTemplateItemInitial.orderQuantity ? item.facilityOrderTemplateItemInitial.orderQuantity : "blank")}></div>}
										{item.product &&
											<input
												className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
												onKeyDown={handleKeyDown} 
												onPaste={handlePaste}
												onClick={(e) => handleItemClick(e)}
												onChange={async (e) => { await editItem(item, parseInt(e.target.value), 'orderQuantity') }}
												onBlur={() => { updateItem(item, facilityOrderTemplate, false, true) }}
												value={item.orderQuantity}
												type="number"
												min="0"
												disabled={disabled || disabledSendOrder || disabledPatient}
											/>
										}
									</td>
								}
								<td className="table-col-input">
									<ReactTooltip positionStrategy="fixed" id={"registerTipItemChangedNote" + item.id} place="top" />
									{item.isNoteChanged && <div className="table-col-input__notif" data-tooltip-id={"registerTipItemChangedNote" + item.id} data-tooltip-content={"Previous: " + (item.facilityOrderTemplateItemInitial && item.facilityOrderTemplateItemInitial.note ? item.facilityOrderTemplateItemInitial.note : "blank")}></div>}
									{(!isMasterPatient && isFormula
										) ? (
										<input
											className="input--table input--inherit-color no-arrows input--text-align--left w--100 u-mar--left--tny"
											onClick={() => openFacilityOrderTemplateItemNewFlowCalculationModal(facilityOrderTemplate.id, facilityOrderTemplate.facilityOrderTemplateItems, index)}
											value={item.note}
											readOnly={true}
											disabled={disabled || disabledSendOrder || disabledPatient}
										/>
										) : (
										<input
											className="input--table input--inherit-color no-arrows input--text-align--left w--100 u-mar--left--tny"
											onClick={isFormula ? () => openFacilityOrderTemplateItemNewFlowCalculationModal(facilityOrderTemplate.id, facilityOrderTemplate.facilityOrderTemplateItems, index) : (e) => e.target.select()}
											onChange={(e) => { item.note = e.target.value }}
											onBlur={() => { updateItem(item, facilityOrderTemplate, true) }}
											value={item.note}
											disabled={disabled || disabledPatient || !item.product}
											readOnly={isFormula}
										/>
										)
									}
								</td>
								<td className="type--center is-hidden">
									<div className="table__icons">
										{item.importActionId && (item.importActionId !== pageViewStore.insertImportActionId) && (
												<Button
													disabled={disabled || disabledSendOrder || disabledPatient}
													className="btn btn--icon"
													icon="u-icon u-icon--update-table u-icon--sml"
													label="Change"
													onlyIcon={true}
													title={"Swap"}
													onClick={() => setImportActionToDeleteAndAddItem(item, facilityOrderTemplate.facilityOrderTemplateItems, index, facilityOrderTemplate.id)}
												></Button>)
										}
										{item.importActionId === pageViewStore.deleteImportActionId ?
											<Button
												className="btn btn--icon is-delete"
												icon="u-icon u-icon--sml u-icon--undo--table"
												label="Undelete"
												onlyIcon={true}
												onClick={() => setImportAction(facilityOrderTemplate.id, item, "update", true)}
												disabled={disabled || disabledSendOrder || disabledPatient}
												title={"Undo"}
											></Button>
											:
											<Button
												className="btn btn--icon is-delete"
												icon={`u-icon u-icon--sml ${!item.product ? "u-icon--close--table" : "u-icon--delete--primary"}`}
												onlyIcon={true}
												onClick={() => { deleteFacilityOrderTemplateItem(facilityOrderTemplate.facilityOrderTemplateItems, index, facilityOrderTemplate.id) }}
												disabled={disabled || disabledSendOrder || disabledPatient}
												title={!item.product ? "Cancel" : "Delete"}
											></Button>
										}
									</div>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
			{
				(facilityOrderTemplate.facilityOrderTemplateItems && !facilityOrderTemplate.facilityOrderTemplateItems.some(x => !x.productId) &&
					<button className={`table--secondary__add-button${(disabled || disabledSendOrder || disabledPatient) ? ' is-disabled' : ''}`} onClick={() => { addEmptyItem(facilityOrderTemplate.id) }} disabled={disabled || disabledSendOrder || disabledPatient}>
						<span></span>
					</button>
				)
			}
		</div>
	);
});

FacilityOrderTemplateTable.propTypes = {
	facilityOrderPatientNewFlowUSIntakePreviewViewStore: PropTypes.object.isRequired,
	facilityOrderTemplate: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	disabledSendOrder: PropTypes.bool
};

const FacilityOrderTemplateDischargesTable = observer(({ facilityOrderTemplate, facilityOrderPatientNewFlowUSIntakePreviewViewStore, disabled, facilityOrderStatus }) => {
	const {
		getSelectedInactiveOption,
		inactiveOptions,
		disabledPatient,
		facilityOrder,
		activateTemplate,
		setTemplateStatus,
		unreviewDischargeTemplates,
		reviewDischargeTemplates,
		updatePortalNote,
		changeItemsVisibility,
		isMasterPatient,
		editItem,
		updateItem,
		openFacilityOrderTemplateItemNewFlowCalculationModal,
		setImportAction,
		deleteFacilityOrderTemplateItem,
		pageViewStore
	} = facilityOrderPatientNewFlowUSIntakePreviewViewStore;

	const handleDropDownItemsOnClick = async (e, facilityOrderTemplateId) => {
		if (facilityOrderStatus && facilityOrderStatus.completedOn) {
			activateTemplate(facilityOrderTemplateId);
		}
		else {
			if (e.item.text === "No changes") {
				setTemplateStatus("no-change", facilityOrderTemplateId, inactiveOptions[3].id, true);
			}
			else if (e.item.text === "Change/Review") {
				setTemplateStatus("change", facilityOrderTemplateId, inactiveOptions[3].id, true);
			}
			else if (e.item.text === "Discontinued") {
				setTemplateStatus("discharge", facilityOrderTemplateId, inactiveOptions[3].id, true);
			}
		}
	}

	const isUnreviewDisabled = disabledPatient || disabled || !!(facilityOrderStatus && facilityOrderStatus.completedOn) || (facilityOrderTemplate.isClinicalReviewed && (!!facilityOrder.facilityOrderStatuses.find(x => x.status && x.status.abrv === "clinical-review")));

	return (
		<div className={`table--secondary__wrapper u-mar--bottom--med--condition is-add-new-disabled ${getSelectedInactiveOption("us-intake", facilityOrderTemplate)}`}>
			<ReactTooltip positionStrategy="fixed" id={"registerTemplateTip" + facilityOrderTemplate.id} place="bottom" />
			<table width="100%" className="table--secondary">
				<colgroup>
					<col width={400} />
					<col width={150} />
					<col width={90} />
					<col />
					<col width={70} />
				</colgroup>
				<thead>
					<tr>
						<th colSpan={"5"}>
							<div className="u-flex--space-between">
								<label>{facilityOrderTemplate.subCategory && facilityOrderTemplate.subCategory.name.toUpperCase()}</label>
								<div className="u-flex--default u-align--h--right">
									{facilityOrderTemplate.inactiveReasonId == "58" &&
										<div className="card--tertiary__status">
											<div className="status--sqare__holder danger">
												<DropDownButton
													text="DISCONTINUED"
													fillMode={"solid"}
													themeColor={"primary"}
													onItemClick={(e) => handleDropDownItemsOnClick(e, facilityOrderTemplate.id)}
													buttonClass={`btn btn--base btn--ghost k-dropdown-button--icons status--sqare ${facilityOrderTemplate.newFlowStatusId === pageViewStore.noChangeNewFlowStatusId ? "success" : facilityOrderTemplate.newFlowStatusId === pageViewStore.changeNewFlowStatusId ? "warning" : facilityOrderTemplate.newFlowStatusId === pageViewStore.dischargeNewFlowStatusId ? "danger" : ""}`}
													disabled={disabled || disabledPatient}
													popupSettings={{
														animate: false,
														anchorAlign: { horizontal: "right", vertical: "bottom" },
														popupAlign: { horizontal: "right", vertical: "top" },
														popupClass: 'is-clean'
													}}
												>
													{facilityOrderTemplate.newFlowStatusId !== pageViewStore.noChangeNewFlowStatusId && <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--success" text="No changes" />}
													{facilityOrderTemplate.newFlowStatusId !== pageViewStore.changeNewFlowStatusId && <DropDownButtonItem iconClass="u-icon u-icon--xmed u-icon--warning-triangle" text="Change/Review" />}
												</DropDownButton>
											</div>
										</div>
									}
									{facilityOrderTemplate.isReviewed ?
										<div data-tooltip-content={facilityOrderTemplate.isClinicalReviewed && isUnreviewDisabled ? "Template is clinically reviewed" : "Unreview"} data-tooltip-id={"registerTemplateTip" + facilityOrderTemplate.id}>
											<BaasicButton
												className="btn btn--icon btn--icon--sml-med btn--primary u-mar--left--xsml"
												icon="u-icon u-icon--med u-icon--unreview"
												label=""
												onlyIcon={false}
												onClick={() => { unreviewDischargeTemplates(facilityOrderTemplate.id) }}
												disabled={isUnreviewDisabled}
											></BaasicButton>
										</div>
										:
										<div data-tooltip-content="Review" data-tooltip-id={"registerTemplateTip" + facilityOrderTemplate.id}>
											<BaasicButton
												className="btn btn--icon btn--icon--sml-med btn--primary u-mar--left--xsml"
												icon="u-icon u-icon--med u-icon--check-list"
												label=""
												onlyIcon={false}
												onClick={() => { reviewDischargeTemplates(facilityOrderTemplate.id) }}
												disabled={disabledPatient || disabled}
											></BaasicButton>
										</div>
									}
								</div>
							</div>
							{facilityOrderTemplate.portalNote &&
								<div className={`u-mar--top--sml c-message has-input u-flex--default w--100 c-message--note--discontinued`}>
									<i className="u-icon u-icon--sml u-icon--add-note" />
									<input
										className="input input--sml input--message u-flex--grow--1 type--sml"
										onClick={(e) => e.target.select()}
										onChange={(e) => { facilityOrderTemplate.portalNote = e.target.value }}
										onBlur={async () => { await updatePortalNote(facilityOrderTemplate.id, facilityOrderTemplate.portalNote) }}
										value={facilityOrderTemplate.portalNote}
										disabled={disabled}
									/>
								</div>
							}
						</th>
					</tr>
				</thead>
				<tbody style={{ opacity: "0.5" }}>
					<tr>
						<td colSpan={5} className="table--secondary__last card--tertiary__body u-cursor--pointer" onClick={() => { changeItemsVisibility(facilityOrderTemplate) }}>
							<div className="">
								<div className="u-flex u-flex--default">
									<span className="type--color--opaque"> {facilityOrderTemplate.itemsVisible ? "Hide Items" : "See Items"}</span>
									<i className={"u-icon u-icon--xsml " + (facilityOrderTemplate.itemsVisible ? "u-icon--arrow-up" : "u-icon--arrow-down") + " u-mar--left--sml"} />
								</div>
							</div>
						</td>
					</tr>
					{facilityOrderTemplate.itemsVisible && facilityOrderTemplate.facilityOrderTemplateItems && facilityOrderTemplate.facilityOrderTemplateItems.map((item, index) => {
						return (
							<tr key={item.id} className={(facilityOrderTemplate.importActionId !=  pageViewStore.insertImportActionId && item.importActionId === pageViewStore.insertImportActionId) ? "new-row" : (item.importActionId === pageViewStore.deleteImportActionId ? "deleted-row" : "")}>
								<td className="is-flex">
									{item.product && item.product.description} <span className="table__icons-wrapper u-mar--left--auto"> {item.product && !item.product.billableToMedicare && <i className="u-icon u-icon--sml u-icon--non-billable"></i>} {(item.backordered != null ? item.backordered : item.product && item.product.backordered) && <i className="u-icon u-icon--med-lrg u-icon--backordered"></i>}</span>
								</td>
								<td>
									{item.product && item.product.itemId}
								</td>
								<td className="table-col-input">
									<ReactTooltip positionStrategy="fixed" id={"registerTipItemChanged" + item.id} place="top" />
									{item.isTemplateQuantityChanged && <div className="table-col-input__notif" data-tooltip-id={"registerTipItemChanged" + item.id} data-tooltip-content={"Previous: " + (item.facilityOrderTemplateItemInitial && item.facilityOrderTemplateItemInitial.templateQuantity ? item.facilityOrderTemplateItemInitial.templateQuantity : "blank")}></div>}
									{item.product &&
										<input
											className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
											onKeyDown={handleKeyDown} 
											onPaste={handlePaste}
											onClick={(e) => e.target.select()}
											onChange={(e) => { editItem(item, parseInt(e.target.value), 'templateQuantity') }}
											onBlur={() => { updateItem(item, facilityOrderTemplate, false, true) }}
											value={item.templateQuantity}
											type="number"
											min="0"
											disabled={disabled || disabledPatient || isMasterPatient}
										/>
									}
									{(item.sendSeparatelyQty | 0) > 0 && <i className="u-icon u-icon--ss u-icon--sml table__icon--ss" data-tooltip-id={"registerTipItemChanged" + item.id} data-tooltip-content={item.sendSeparatelyQty} />}
								</td>
								<td className="table-col-input">
									<ReactTooltip positionStrategy="fixed" id={"registerTipItemChangedNote" + item.id} place="top" />
									{item.isNoteChanged && <div className="table-col-input__notif" data-tooltip-id={"registerTipItemChangedNote" + item.id} data-tooltip-content={"Previous: " + (item.facilityOrderTemplateItemInitial && item.facilityOrderTemplateItemInitial.note ? item.facilityOrderTemplateItemInitial.note : "blank")}></div>}
									{(!isMasterPatient && item.product && (item.product.itemTypeId || (item.product.procedureCode_ && item.product.procedureCode_.abrv === "B4155"))
										) ? (<input
											className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
											onClick={() => openFacilityOrderTemplateItemNewFlowCalculationModal(facilityOrderTemplate.id, facilityOrderTemplate.facilityOrderTemplateItems, index)}
											value={item.note}
											disabled={disabled || disabledPatient}
										/> ) : (
										<input
											className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
											onClick={(e) => e.target.select()}
											onChange={(e) => { item.note = e.target.value }}
											onBlur={() => { updateItem(item, facilityOrderTemplate, true) }}
											value={item.note}
											disabled={disabled || disabledPatient}
										/>)
									}
								</td>
								<td className="type--center is-hidden">
									<div className="table__icons">
										{item.importActionId === pageViewStore.deleteImportActionId ?
											<Button
												className="btn btn--icon"
												icon="u-icon u-icon--sml u-icon--undo--table"
												label="Undelete"
												onlyIcon={true}
												onClick={() => setImportAction(facilityOrderTemplate.id, item, "update", true)}
												disabled={disabled || disabledPatient}
												title={"Undo"}
											></Button>
											:
											<Button
												className="btn btn--icon is-delete"
												icon={`u-icon u-icon--sml ${!item.product ? "u-icon--close--table" : "u-icon--delete--primary"}`}
												onlyIcon={true}
												onClick={() => { deleteFacilityOrderTemplateItem(facilityOrderTemplate.facilityOrderTemplateItems, index, facilityOrderTemplate.id) }}
												disabled={disabled || disabledPatient}
												title={!item.product ? "Cancel" : "Delete"}
											></Button>
										}
									</div>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</div>
	);
});

FacilityOrderTemplateDischargesTable.propTypes = {
	facilityOrderPatientNewFlowUSIntakePreviewViewStore: PropTypes.object.isRequired,
	facilityOrderTemplate: PropTypes.object.isRequired,
	disabled: PropTypes.bool
};
export default defaultTemplate(FacilityOrderPatientNewFlowUSIntakePreviewTemplate);